<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"/>
    <b-row>
      <b-col xl="6" sm="12" md="12">
        <div class="card">
          <div class="card-header">
            <span class="title ml-3">Cadastro da empresa</span>
            <button
              class="btn btn-success float-right mr-3"
              data-style="expand-right"
              data-spinner-size="20"
              data-spinner-lines="30"
              type="submit"
              disabled
            >Salvar</button>
          </div>
          <div class="card-body">
            <b-col cols="12">
              <b-input-group prepend="Fidelização">
                <b-form-input v-model="tipoFidelizacao" disabled/>
              </b-input-group>
            </b-col>
            <b-col cols="12">
              <b-input-group prepend="Cor do Email" class="mt-3" ref="colorpicker">
                <b-form-input
                  v-model="colorValue"
                  @focus="showPicker()"
                  @input="updateFromInput"
                  disabled
                />
                <b-input-group-append>
                  <span class="input-group-addon color-picker-container">
                    <span
                      class="current-color"
                      :style="'background-color: ' + colorValue"
                      @click="togglePicker()"
                    ></span>
                    <chrome-picker :value="colors" @input="updateFromPicker" v-if="displayPicker"/>
                  </span>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col cols="12">
              <b-input-group class="mt-3">
                <b-input-group-prepend is-text>
                  <i class="fa fa-mobile fa-lg"></i>&nbsp;por usuário
                </b-input-group-prepend>
                <b-form-input v-model="dispositivosUsuario" disabled/>
              </b-input-group>
            </b-col>
          </div>
        </div>
      </b-col>
      <b-col xl="6" sm="12" md="12">
        <div class="card">
          <div class="card-header">
            <span class="title ml-3">Configurações SMTP</span>
            <button
              class="btn btn-success float-right mr-3"
              data-style="expand-right"
              data-spinner-size="20"
              data-spinner-lines="30"
              type="submit"
              disabled
            >Salvar</button>
          </div>
          <div class="card-body">
            <b-col cols="12">
              <b-input-group prepend="Host" class="mt-3">
                <b-form-input v-model="hostSMTP" disabled/>
              </b-input-group>
            </b-col>
            <b-col cols="12">
              <b-input-group prepend="Usuário" class="mt-3">
                <b-form-input v-model="usernameSMTP" disabled/>
              </b-input-group>
            </b-col>
            <b-col cols="12">
              <b-input-group prepend="Senha" class="mt-3">
                <b-form-input type="password" v-model="passwordSMTP" disabled/>
              </b-input-group>
            </b-col>
            <b-col cols="12">
              <b-input-group prepend="Porta" class="mt-3">
                <b-form-input v-model="portSMTP" disabled/>
              </b-input-group>
            </b-col>
            <b-col cols="12">
              <b-input-group prepend="Email envio" class="mt-3">
                <b-form-input v-model="fromSMTP" disabled/>
              </b-input-group>
            </b-col>
            <b-col cols="12">
              <b-input-group prepend="Nome envio" class="mt-3">
                <b-form-input v-model="nameSMTP" disabled/>
              </b-input-group>
            </b-col>
            <b-col cols="12">
              <b-input-group class="mt-3">
                <b-input-group-prepend is-text>
                  <input type="checkbox" v-model="tls" aria-label="Checkbox for following text input" disabled>
                  <span class="ml-2">TLS</span>
                </b-input-group-prepend>
              </b-input-group>
              <b-input-group class="mt-3">
                <b-input-group-prepend is-text>
                  <input type="checkbox" v-model="ssl" aria-label="Checkbox for following text input" disabled>
                  <span class="ml-2">SSL</span>
                </b-input-group-prepend>
              </b-input-group>
            </b-col>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";

import * as VueColor from "vue-color";
import axios from "axios";
import * as config from "@/config.json";

var Chrome = VueColor.Chrome;

export default {
  name: "Opções",
  components: { Loading, "chrome-picker": Chrome },
  data() {
    return {
      isLoading: false,
      hostSMTP: "br836.hostgator.com.br",
      usernameSMTP: "accesys",
      passwordSMTP: "ADMACCESYS1",
      portSMTP: "587",
      fromSMTP: "naoresponda@accesys.com.br",
      nameSMTP: "naoresponda",
      tls: false,
      ssl: true,
      tipoFidelizacao: "Sem programa de fidelização",
      dispositivosUsuario: "2",
      colors: {
        hex: "#002777"
      },
      colorValue: "",
      displayPicker: false
    };
  },
  mounted() {
    this.setColor(this.color || "#002777");
  },
  methods: {
    setColor(color) {
      this.updateColors(color);
      this.colorValue = color;
    },
    updateColors(color) {
      if (color.slice(0, 1) == "#") {
        this.colors = {
          hex: color
        };
      } else if (color.slice(0, 4) == "rgba") {
        var rgba = color.replace(/^rgba?\(|\s+|\)$/g, "").split(","),
          hex =
            "#" +
            (
              (1 << 24) +
              (parseInt(rgba[0]) << 16) +
              (parseInt(rgba[1]) << 8) +
              parseInt(rgba[2])
            )
              .toString(16)
              .slice(1);
        this.colors = {
          hex: hex,
          a: rgba[3]
        };
      }
    },
    showPicker() {
      document.addEventListener("click", this.documentClick);
      this.displayPicker = true;
    },
    hidePicker() {
      document.removeEventListener("click", this.documentClick);
      this.displayPicker = false;
    },
    togglePicker() {
      this.displayPicker ? this.hidePicker() : this.showPicker();
    },
    updateFromInput() {
      this.updateColors(this.colorValue);
    },
    updateFromPicker(color) {
      this.colors = color;
      if (color.rgba.a == 1) {
        this.colorValue = color.hex;
      } else {
        this.colorValue =
          "rgba(" +
          color.rgba.r +
          ", " +
          color.rgba.g +
          ", " +
          color.rgba.b +
          ", " +
          color.rgba.a +
          ")";
      }
    },
    documentClick(e) {
      var el = this.$refs.colorpicker,
        target = e.target;
      if (el !== target && !el.contains(target)) {
        this.hidePicker();
      }
    },
    redirectUser() {
      this.$router.push("/opcoes/contatos");
    }
  },
  watch: {
    colorValue(val) {
      if (val) {
        this.updateColors(val);
        this.$emit("input", val);
        //document.body.style.background = val;
      }
    }
  },
  beforeMount() {
    axios
      .get(
        `${
          config.default.servidor
        }/gerencial/retorna-configuracoes/${localStorage
          .getItem("enterprise_id")
          .toString()}`,
        {
          headers: {
            Authorization: "Basic c2E6QURNQUNDRVNZUw=="
          }
        }
      )
      .then(response => {
        if(response.status === 200) {
          const e = response.data.data
          this.hostSMTP = e.host;
          this.usernameSMTP = e.usuario;
          this.passwordSMTP = e.senha;
          this.portSMTP = e.porta;
          this.fromSMTP = e.email_envio;
          this.nameSMTP = e.nome_envio;
          this.tls = e.tls;
          this.ssl = e.ssl;
        }
      });
  }
};
</script>

